export { default } from './isImmutableOrderedSet'
